import { routerMiddleware, routerReducer } from 'react-router-redux';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { createResponsiveStateReducer, responsiveStoreEnhancer } from 'redux-responsive';
import thunk from 'redux-thunk';
import api from '../middleware/api';
import reducers from '../reducers';
const isProduction = process.env.NODE_ENV === 'production';
const isTest = process.env.NODE_ENV === 'test';
let composeEnhancers = compose;
if (!isProduction && !isTest) {
    // @ts-expect-error TS2339: Property __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ does not exist on type Window & typeof globalThis
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}
const configureStore = (history) => {
    return createStore(combineReducers({
        ...reducers,
        browser: createResponsiveStateReducer(),
        router: routerReducer,
    }), composeEnhancers(responsiveStoreEnhancer, 
    // @ts-expect-error TS2769: No overload matches this call.
    applyMiddleware(thunk, api, routerMiddleware(history), createLogger())));
};
export default configureStore;
